import { DropdownItem } from "@mcleod/components";
import { AutogenLayoutCustomerOrderHistory } from "./autogen/AutogenLayoutCustomerOrderHistory";

export class CustomerOrderHistory extends AutogenLayoutCustomerOrderHistory {

    override onLoad() {
        this.setComboValues();
    }

    private setComboValues() {
        this.textboxBillOrderedDistance.items = [
            new DropdownItem("B", "Bill Date"),
            new DropdownItem("O", "Ordered Date")
        ];
    }
}
